/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Mifflin-St Jeor equation, widely considered one of the most accurate for estimating resting metabolic rate.`)
};

const es_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ecuación de Mifflin-St Jeor, ampliamente considerada una de las más precisas para estimar la tasa metabólica en reposo.`)
};

const de_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Mifflin-St Jeor-Gleichung, die allgemein als eine der genauesten zur Schätzung des Grundumsatzes angesehen wird.`)
};

const nl_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Mifflin-St Jeor-vergelijking, algemeen beschouwd als één van de nauwkeurigste voor het inschatten van rustmetabolisch tarief.`)
};

const fr_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'équation de Mifflin-St Jeor, largement considérée comme l'une des plus précises pour estimer le taux métabolique au repos.`)
};

const it_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'equazione di Mifflin-St Jeor, ampiamente considerata una delle più accurate per stimare il metabolismo basale.`)
};

const pt_br2_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A equação de Mifflin-St Jeor, amplamente considerada uma das mais precisas para estimar taxa metabólica basal.`)
};

const pt_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A equação de Mifflin-St Jeor, amplamente considerada uma das mais precisas para estimar a taxa metabólica em repouso.`)
};

const ja_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mifflin-St Jeor方程式は、安静時代謝率を推定するための最も正確な公式の1つと広く見なされています。`)
};

const zh_bmr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mifflin-St Jeor 公式，被广泛认为是估算静息代谢率最准确的公式之一。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq2_a", locale)
	if (locale === "en") return en_bmr_faq2_a(inputs)
	if (locale === "es") return es_bmr_faq2_a(inputs)
	if (locale === "de") return de_bmr_faq2_a(inputs)
	if (locale === "nl") return nl_bmr_faq2_a(inputs)
	if (locale === "fr") return fr_bmr_faq2_a(inputs)
	if (locale === "it") return it_bmr_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq2_a(inputs)
	if (locale === "pt") return pt_bmr_faq2_a(inputs)
	if (locale === "ja") return ja_bmr_faq2_a(inputs)
	return zh_bmr_faq2_a(inputs)
};